/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ModuleList = zod.strictObject({
    name: zod.string(),
    codename: zod.string(),
    is_activated_for_user: zod.boolean(),
});

export type ModuleList = zod.input<typeof ModuleList>;
export type ModuleListOutput = zod.output<typeof ModuleList>;
